module.exports = __webpack_public_path__ + "media/images/quote-white-22654bbc2569610926a6173042be1e01.svg";